export default "__VITE_ASSET__DzS8jAYn__"